
<div class="relative" :class="textfieldClasses">
  <input
    :id="id"
    :ref="refName"
    v-model="content"
    :data-maska="mask"
    :class="`text-field-input ${hasIcon ? 'pr-56' : 'pr-16'}`"
    :type="type"
    :aria-label="ariaLabel"
    :aria-invalid="hasError"
    :aria-describedby="ariaDescribedByName"
    :required="required"
    :disabled="disabled"
    :readonly="readonly"
    :pattern="pattern"
    :maxlength="maxlength"
    :value="content"
    :inputmode="inputmode"
    :placeholder="placeholder"
    :name="name"
    :autocomplete="autocomplete"
    @blur="$emit('blur')"
    @keydown.enter="handleKeydownEnter"
  />
  <label :class="'pointer-events-none ' + textfieldLabelFilled" :for="id">{{ labelName }}</label>
  <div v-if="hasIcon" class="text-field-icon">
    <slot v-if="(!hasError && !disabled) || iconStatic" name="icon" />
  </div>
  <HelperText v-if="helperText" :id="id" :text="helperText" :status="status" />
</div>
